module.exports = __webpack_public_path__ + "static/media/cabinet-2.ed54cfa7.webp";